// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3DpUG","validationTips":"StatementDescriptor_validationTips__3hK_y"};